//@flow
import React from 'react';

import {makeStyles, TableCell, Typography} from '@material-ui/core';
import {useState} from 'react';
import {useProductVariantContext} from '../../../context/productVariant';
import {getImageUrl} from '../../../../../utils/image_provider';

import ProductImagesModal from '../../../../../elements/ProductImagesModal';
import {useProductContext} from '../../../context';
import {useChangeVariantImage} from '../../../utils/editProduct';

const useStyles = makeStyles(theme => ({
  cell: {
    display: 'flex',
    alignItems: 'center',
    gap: '.5rem',
    minWidth: 'max-content',
  },
  productImageButton: {
    width: '2.75rem',
    height: '2.75rem',
    borderRadius: '.5rem',
    overflow: 'hidden',
    cursor: 'pointer',
    padding: 0,
    margin: 0,
    border: 'none',
    background: 'none',
  },
  productImage: {
    width: '100%',
    height: '100%',

    '& img': {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      transition: 'transform .2s ease-in-out',
    },

    '&:hover img': {
      transform: 'scale(1.1)',
    },
  },
}));

export default function VariantImageCell() {
  const classes = useStyles();

  const [images, setProduct] = useProductContext(product => {
    if (Array.isArray(product.images)) {
      return product.images;
    }

    if (product.mainImageId) {
      return [
        {
          id: product.mainImageId,
          number: 0,
        },
      ];
    }

    return [];
  });

  const {
    changeVariantImage,
    addNewVariantImage,
    loading,
  } = useChangeVariantImage();

  const variant = useProductVariantContext();

  const [variantImage, setVariantImage] = useState(
    getImageUrl(variant.imageId)
  );

  const [selectImageModalOpen, setSelectImageModalOpen] = useState(false);

  const openCropModal = () => setSelectImageModalOpen(true);
  const closeCropModal = () => setSelectImageModalOpen(false);

  return (
    <TableCell component="th" scope="row">
      <div className={classes.cell}>
        {/* <Checkbox color="primary" /> */}
        <button className={classes.productImageButton} onClick={openCropModal}>
          <picture className={classes.productImage}>
            <img src={variantImage} alt="product" />
          </picture>
        </button>
        <Typography className={classes.infoText}>
          {Object.values(variant.combinations).join('/')}
        </Typography>
      </div>
      {selectImageModalOpen && (
        <ProductImagesModal
          images={images.map(({id}) => ({preview: getImageUrl(id), id}))}
          defaultSelected={variantImage}
          selectedLabel="Imagen"
          canSelect
          canUpload
          selectOnUpload
          loading={loading}
          onSave={result => {
            if (!result.imageSelected) return;
            const {isNew, id, file} = result.imageSelected;

            if (!isNew && id) {
              changeVariantImage(id);
              setVariantImage(getImageUrl(id));
              closeCropModal();
              return;
            }

            if (isNew && file) {
              addNewVariantImage(file).then(id => {
                setVariantImage(getImageUrl(id));
                closeCropModal();
                setProduct({
                  images: [
                    ...images,
                    {
                      id,
                      number: images.length,
                    },
                  ],
                });
              });
            }
          }}
          onClose={closeCropModal}
          open={selectImageModalOpen}
        />
      )}
    </TableCell>
  );
}
